import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authMe } from '../api';

const ProtectedRoute = ({ children }) => {
  // Fast client gate: if no local flag, never bother the server.
  const hasLocalFlag = localStorage.getItem('managerLoggedIn') === 'true';

  // null = verifying, true = valid session, false = invalid
  const [sessionValid, setSessionValid] = useState(hasLocalFlag ? null : false);

  useEffect(() => {
    if (!hasLocalFlag) return;
    let active = true;
    (async () => {
      try {
        await authMe();
        if (active) setSessionValid(true);
      } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          // Session expired/invalid on the server -> force logout
          localStorage.removeItem('managerLoggedIn');
          localStorage.removeItem('managerName');
          localStorage.removeItem('googleAuth');
          localStorage.removeItem('sessionId');
          localStorage.removeItem('authToken');
          if (active) setSessionValid(false);
        } else {
          // Transient/network error -> trust the local flag, keep the user in
          if (active) setSessionValid(true);
        }
      }
    })();
    return () => { active = false; };
  }, [hasLocalFlag]);

  if (sessionValid === false) {
    return <Navigate to="/" replace />;
  }

  if (sessionValid === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
